import(/* webpackMode: "eager" */ "/codebuild/output/src1291456030/src/src/app/global-error.tsx");
